module.exports = __webpack_public_path__ + "img/2heart-11.b6c29005.svg";